import { registerCondition } from 'core/forms';

const isHiddenRelationshipType = ({ model }) => ({
  condition: null,
  hasCondition: ['elected', 'instructor'].includes(model.relationship_type),
});

registerCondition('isHiddenRelationshipType', isHiddenRelationshipType);

export default isHiddenRelationshipType;
